import { client as axios } from '../../axios/client';
import {
  GET_HISTORY_REQUEST,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE
} from './historyTypes';

/**
 * Obtiene el historial de un ticket, enriqueciendo los datos en el frontend.
 * @param {string} ticketId - ID del ticket
 * @param {string} token - Token de autenticación
 */
export const getTicketHistory = (ticketId, token) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_HISTORY_REQUEST });

    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await axios.get(`/kanban/tickets/${ticketId}/history`, { headers });

    const rawHistory = response.data || [];
    const state = getState(); // Obtenemos el estado global de Redux

    // 1. Crear mapa de búsqueda para columnas del estado de kanban
    const columns = state.kanban.columns?.items || [];
    const columnMap = columns.reduce((acc, col) => {
      acc[col.id] = col.name;
      return acc;
    }, {});

    // 2. Crear mapa de búsqueda para agentes del estado de agentes
    const agents = state.agentes.agents?.items || [];
    const agentMap = agents.reduce((acc, agent) => {
      acc[agent._id] = agent.email ? agent.email.split('@')[0] : agent.display_name;
      return acc;
    }, {});

    // 3. Enriquecer el historial con los nombres de las columnas y agentes
    const enrichedHistory = rawHistory.map(entry => ({
      ...entry,
      old_column_name: columnMap[entry.old_column_id] || null, // null si no se encuentra
      new_column_name: columnMap[entry.new_column_id] || 'Columna desconocida',
      agent_name: entry.agent_name || agentMap[entry.changed_by_id_agent] || 'Agente desconocido'
    }));

    dispatch({
      type: GET_HISTORY_SUCCESS,
      payload: {
        ticketId,
        history: enrichedHistory // Enviamos el historial ya enriquecido al reducer
      }
    });

    return enrichedHistory;
  } catch (error) {
    dispatch({
      type: GET_HISTORY_FAILURE,
      payload: {
        error: error.message || 'Error al obtener historial'
      }
    });
    throw error;
  }
}; 